import { userContext } from 'contexts/UserContext';
import { useContext, useEffect, useState } from 'react';
import type { User } from 'types';

interface Chaport {
  on(event: string, callback: () => void, args?: unknown): void;
  setVisitorData(data: Record<string, unknown>): void;
}

declare global {
  interface Window {
    chaport: Chaport;
  }
}

function getChaport(controller: AbortController): Promise<Chaport> {
  // Текущий таймер
  let timeout: NodeJS.Timeout | null = null;

  return new Promise<Chaport>((resolve, reject) => {
    setTimeout(() => {
      controller.abort(new Error('Время ожидания chaport истекло'));
    }, 10e3);

    // Если была отмена - очищаем таймер
    controller.signal.addEventListener('abort', function handleAbort() {
      if (timeout) {
        clearTimeout(timeout);
      }
      reject(this.reason ?? new Error('Ожидание chaport отменено'));
    });

    const tryGetChaport = () => {
      try {
        window.chaport.on('ready', () => {
          resolve(window.chaport);
        });
      } catch {
        timeout = setTimeout(tryGetChaport, 500);
      }
    };
    tryGetChaport();
  });
}

export function useChaport() {
  const [abortController] = useState(new AbortController());
  const { user } = useContext(userContext) as { user: User | null };

  useEffect(() => {
    let chaport: Chaport | null = null;
    if (!user) return undefined;

    getChaport(abortController)
      .then((c) => {
        chaport = c;
        chaport.setVisitorData({
          name: [user.FamilyName, user.GivenName].filter(Boolean).join(' '),
          email: user.Email
        });
      })
      .catch(console.error);
    return () => {
      try {
        chaport?.setVisitorData({});
      } catch (e) {
        console.error(e);
      }
      try {
        abortController.abort();
      } catch (e) {
        console.error(e);
      }
    };
  }, [abortController, user]);
}
